import React from "react";
import { Phone, Mail } from "lucide-react";
import { CONTACT_PHONE, CONTACT_PHONE_TEL, CONTACT_EMAIL } from "@/components/Nav";

export const StickyContactBar = () => (
  <div
    data-testid="sticky-contact-bar"
    className="fixed bottom-0 inset-x-0 z-40 border-t border-black/20 shadow-[0_-8px_24px_rgba(0,0,0,0.35)]"
  >
    <div className="grid grid-cols-2 max-w-[1600px] mx-auto">
      <a
        href={`tel:${CONTACT_PHONE_TEL}`}
        data-testid="sticky-phone"
        className="group flex items-center justify-center gap-2 md:gap-3 bg-amber-500 hover:bg-amber-400 text-black h-14 md:h-16 px-3 md:px-6 font-mono uppercase tracking-[0.15em] md:tracking-[0.2em] text-[11px] md:text-sm transition-colors border-r border-black/30"
      >
        <Phone className="w-4 h-4 md:w-5 md:h-5 group-hover:animate-pulse" strokeWidth={2.4} />
        <span className="font-bold truncate">{CONTACT_PHONE}</span>
      </a>
      <a
        href={`mailto:${CONTACT_EMAIL}`}
        data-testid="sticky-email"
        className="group flex items-center justify-center gap-2 md:gap-3 bg-black hover:bg-zinc-900 text-amber-500 h-14 md:h-16 px-3 md:px-6 font-mono uppercase tracking-[0.15em] md:tracking-[0.2em] text-[11px] md:text-sm transition-colors border-l border-amber-500"
      >
        <Mail className="w-4 h-4 md:w-5 md:h-5 group-hover:animate-pulse" strokeWidth={2.4} />
        <span className="font-bold truncate">{CONTACT_EMAIL}</span>
      </a>
    </div>
  </div>
);
